import WithSidebar from "../../../layouts/WithSidebar"
import ListHeader from "../../../components/List-header"
import './members.css'
import MemberList from "../../../components/Member-list"

const Members = () => {





    return (
        <WithSidebar pageTitle={"Members of this office"} breadcrumb={"Dashboard > Offices > Office Detail"} listHeaders={<ListHeader detail={false}/>}>
            <MemberList />
        </WithSidebar>
    )
}
export default Members